/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Registrationdate1Inputs */

const en__field_registrationdate1 = /** @type {(inputs: _Field_Registrationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registration`)
};

const de__field_registrationdate1 = /** @type {(inputs: _Field_Registrationdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung`)
};

/**
* | output |
* | --- |
* | "registration" |
*
* @param {_Field_Registrationdate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_registrationdate1 = /** @type {((inputs?: _Field_Registrationdate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Registrationdate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_registrationdate1(inputs)
	return de__field_registrationdate1(inputs)
});
export { _field_registrationdate1 as "_field_registrationDate" }